import { COLORS, ELEVATIONS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '49px',
  },
  pageWrapper: {
    backgroundColor: COLORS.WHITE.DEFAULT,
    borderRadius: '8px',
    padding: '32px',
    minWidth: '1000px',
    boxShadow: ELEVATIONS.LIGHT_LOW,
    paddingBottom: '64px',
    marginTop: '80px',
  },
  titleWrapper: {
    marginBottom: '32px',
  },
  cardsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '32px',
  },
});

export default stylesheet;
